import { createAction } from "@reduxjs/toolkit";
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["fetch"] = "searchResults/fetch";
    ActionTypes["fetchSuccess"] = "searchResults/fetchSuccess";
    ActionTypes["fetchSuccessAutoLoad"] = "searchResults/fetchSuccessAutoLoad";
    ActionTypes["fetchError"] = "searchResults/fetchError";
    ActionTypes["reset"] = "searchResults/reset";
    ActionTypes["hidePrice"] = "searchResults/hidePrice";
    ActionTypes["showPrice"] = "searchResults/showPrice";
    ActionTypes["addVisibleIndexes"] = "searchResults/addVisibleIndexes";
    ActionTypes["clearVisibleIndexes"] = "searchResults/clearVisibleIndexes";
})(ActionTypes || (ActionTypes = {}));
export const actions = {
    fetch: createAction(ActionTypes.fetch, () => ({
        payload: {}
    })),
    fetchSuccess: createAction(ActionTypes.fetchSuccess, (data) => ({
        payload: data
    })),
    fetchSuccessAutoLoad: createAction(ActionTypes.fetchSuccessAutoLoad, (data) => ({
        payload: data
    })),
    fetchError: createAction(ActionTypes.fetchError, (error) => ({
        payload: error
    })),
    reset: createAction(ActionTypes.reset, () => ({
        payload: {}
    })),
    hidePrice: createAction(ActionTypes.hidePrice, () => ({
        payload: {}
    })),
    showPrice: createAction(ActionTypes.showPrice, () => ({
        payload: {}
    })),
    addVisibleIndexes: createAction(ActionTypes.addVisibleIndexes, (indexes) => ({
        payload: indexes
    })),
    clearVisibleIndexes: createAction(ActionTypes.clearVisibleIndexes, () => ({
        payload: {}
    }))
};
